module.exports = __webpack_public_path__ + "static/media/photo42.a8fdb8f1.jpg";